// extracted by mini-css-extract-plugin
export default {"wrap":"rM-z","fullWidth":"sM-z","hideOnDesktop":"tM-z","content":"uM-z","hasOpenedNav":"vM-z","crumbsList":"wM-z","dropdownsWrap":"xM-z"};